import { Injectable } from '@angular/core';
import aesjs from 'aes-js';

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  private _key = 'Vz@AiLK%Fytx+*C';

  private getKey(): Uint8Array {
    // AES requires a 128, 192, or 256-bit key (16, 24, or 32 bytes).
    // Pad or truncate the key to 16 bytes (128 bits).
    const keyBytes = aesjs.utils.utf8.toBytes(this._key);
    return new Uint8Array([...keyBytes, ...new Array(16 - keyBytes.length).fill(0)].slice(0, 16));
  }

  encrypt(text: string): string {
    const key = this.getKey();
    const textBytes = aesjs.utils.utf8.toBytes(text);
    const aesCtr = new aesjs.ModeOfOperation.ctr(key);
    const encryptedBytes = aesCtr.encrypt(textBytes);
    return aesjs.utils.hex.fromBytes(encryptedBytes);
  }

  decrypt(encryptedText: string): string {
    const key = this.getKey();
    const encryptedBytes = aesjs.utils.hex.toBytes(encryptedText);
    const aesCtr = new aesjs.ModeOfOperation.ctr(key);
    const decryptedBytes = aesCtr.decrypt(encryptedBytes);
    return aesjs.utils.utf8.fromBytes(decryptedBytes);
  }
}
